module.exports = __webpack_public_path__ + "img/LogoCon.b9c3732c.png";